import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import OcenySearchbox from "./components/OcenySearchbox";
import OcenySzczegoloweTab from "./components/OcenySzczegoloweTab";
import OcenyKierowcowTab from "./components/OcenyKierowcowTab";
import OcenyPojazdowTab from "./components/OcenyPojazdowTab";
import moment from "moment";
import OcenyService from "./OcenyService";


export default class OcenyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ocenySzczeglowe: [],
            ocenyKierowcow: [],
            ocenyPojazdow: [],

            activeTab: 1,
            dataOd:null,
            dataDo:null,

        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }


    renderContent(){
        if(this.state.activeTab === 1){
            return <OcenySzczegoloweTab ocenySzczeglowe={this.state.ocenySzczeglowe}/>
        }
        else if(this.state.activeTab ===2){
            return <OcenyKierowcowTab ocenyKierowcow={this.state.ocenyKierowcow}/>
        }
        else if(this.state.activeTab ===3){
            return <OcenyPojazdowTab ocenyPojazdow={this.state.ocenyPojazdow}/>
        }
    }

    changeActiveTab(eventKey){
        this.setState({activeTab:eventKey})
    }

    pobierzOcenyOdDoDaty(dataOd,dataDo,trasa){
        OcenyService.pobierzOcenySzczegolowe(dataOd,dataDo,trasa).then(function (response) {
            let arr = Array.from(response.data,item=>{
                return {
                    ...item,
                    klient:item.imieKl+' '+item.nazKl,
                    kierowca:item.imieKi+' '+item.nazKi,
                }
            })
            this.setState({ocenySzczeglowe:arr})
        }.bind(this))
    }

    pobierzOcenyKierowcow(dataOd,dataDo,trasa){
        OcenyService.pobierzOcenyKierowcow(dataOd,dataDo,trasa).then(function (response) {
            let arr = Array.from(response.data,item=>{
                return {
                    ...item,
                    kierowca:item.imieKi+' '+item.nazKi,
                }
            })
            this.setState({ocenyKierowcow:arr})
        }.bind(this))
    }

    pobierzOcenyPojazdow(dataOd,dataDo,trasa){
        OcenyService.pobierzOcenyPojazdow(dataOd,dataDo,trasa).then(function (response) {
            let arr = Array.from(response.data,item=>{
                return {
                    ...item
                }
            })
            this.setState({ocenyPojazdow:arr})
        }.bind(this))
    }

    componentDidMount() {

        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            dataOd: pierwszy_miesiaca._i,
            dataDo:ostatni_miesiaca._i
        })

        this.pobierzOcenyOdDoDaty(pierwszy_miesiaca._i,ostatni_miesiaca._i)
        this.pobierzOcenyKierowcow(pierwszy_miesiaca._i,ostatni_miesiaca._i)
        this.pobierzOcenyPojazdow(pierwszy_miesiaca._i,ostatni_miesiaca._i)

    }

    onClickSzukaj(dataOd,dataDo,trasa){
        this.pobierzOcenyOdDoDaty(dataOd,dataDo,trasa)
        this.pobierzOcenyKierowcow(dataOd,dataDo,trasa)
        this.pobierzOcenyPojazdow(dataOd,dataDo,trasa)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'OcenyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/opinie', text: 'Oceny'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <OcenySearchbox handleClickSzukaj={this.onClickSzukaj}/>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="ebok-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Oceny szczegółowe" >
                                </Tab>
                                <Tab eventKey={2} title="Oceny kierowców">
                                </Tab>
                                <Tab eventKey={3} title="Oceny pojazdów">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop:'15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/OcenyContainer.js